import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Month from './pages/Month'
import Categories from './pages/Categories'
import Merchants from './pages/Merchants'
import Tags from './pages/Tags'
import TransactionEdit from './pages/TransactionEdit'
import Settings from './pages/Settings'
import BizTransactions from './pages/biz/BizTransactions'
import BizInvoices from './pages/biz/BizInvoices'
import BizReceipts from './pages/biz/BizReceipts'
import BizAccounts from './pages/biz/BizAccounts'
import Accounts from './pages/Accounts'
import ReceiptsMobile from './pages/ReceiptsMobile'

// Lazy-loaded providers that make API calls — only mount after auth is confirmed
import { ModeProvider } from './context/ModeContext'
import { BusinessProvider } from './context/BusinessContext'

function AuthenticatedApp() {
  return (
    <ModeProvider>
      <BusinessProvider>
        <Routes>
          <Route element={<Layout />}>
            {/* Personal routes */}
            <Route index element={<Dashboard />} />
            <Route path="month" element={<Month />} />
            <Route path="categories" element={<Categories />} />
            <Route path="merchants" element={<Merchants />} />
            <Route path="tags" element={<Tags />} />
            <Route path="transactions/new" element={<TransactionEdit />} />
            <Route path="transactions/:id/edit" element={<TransactionEdit />} />
            <Route path="settings" element={<Settings />} />
            <Route path="accounts" element={<Accounts />} />

            {/* Business routes */}
            <Route path="biz" element={<BizTransactions />} />
            <Route path="biz/transactions/:id/edit" element={<TransactionEdit />} />
            <Route path="biz/invoices" element={<BizInvoices />} />
            <Route path="biz/receipts" element={<BizReceipts />} />
            <Route path="biz/accounts" element={<BizAccounts />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BusinessProvider>
    </ModeProvider>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            {/* Mobile receipt capture — outside AuthenticatedApp so it never mounts
                BusinessProvider/Dashboard and makes zero data calls (no SQL wake). */}
            <Route path="/m" element={<ReceiptsMobile />} />
            <Route path="/*" element={<AuthenticatedApp />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
